"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TransactionOptions = void 0;
const constants_1 = require("./constants");
class TransactionOptions {
    constructor(value) {
        this.value = value;
    }
    static withTxHashSignOptions() {
        return new TransactionOptions(constants_1.TRANSACTION_OPTIONS_TX_HASH_SIGN);
    }
    valueOf() {
        return this.value;
    }
}
exports.TransactionOptions = TransactionOptions;
//# sourceMappingURL=transactionOptions.js.map